import { Container, Breakpoints, ContainerPadding, CTA } from '@volkswagen-onehub/components-core';
import { Close } from '@volkswagen-onehub/icons-core';
import React from 'react';
import { IPortalContext, PortalContext } from '../../../../../context/portal-context';
import { ClubSettings } from '../club-settings';
import styled from 'styled-components';

const CTARelativeContainer = styled.div`
	position: relative;
	z-index: 1000;
`;

export const ClubSettingsLayer = ({
	portalContext,
	onClose,
}: {
	portalContext: IPortalContext;
	onClose: () => void;
}) => {
	return (
		<PortalContext.Provider value={portalContext}>
			<CTARelativeContainer className="cta__relative-container">
				<Container
					wrap={'never'}
					horizontalAlign={'flex-end'}
					verticalAlign={'center'}
					padding={{
						top: {
							[Breakpoints.default]: ContainerPadding.dynamic0130,
							[Breakpoints.b960]: ContainerPadding.dynamic0140,
						},
						right: {
							[Breakpoints.default]: ContainerPadding.grid001,
							[Breakpoints.b960]: ContainerPadding.dynamic0100,
							[Breakpoints.b1280]: ContainerPadding.dynamic0140,
						},
						bottom: ContainerPadding.dynamic0050,
					}}
				>
					<CTA
						tag="button"
						emphasis="tertiary"
						onClick={onClose}
						aria-label="closePopUp"
						icon={<Close variant="default" aria-hidden />}
					/>
				</Container>
			</CTARelativeContainer>
			<ClubSettings handleClose={onClose} />
		</PortalContext.Provider>
	);
};
